import axios from 'axios';
import { FetchEmbedConfigDTO } from 'common/Types/EmbeddedContentTypes';
import configData from 'config.json';

export const embedConfigRequest = async (dto: FetchEmbedConfigDTO) => { 
  try {
    return await axios.post(`${configData.ENDPOINT_ALX_APIBASEURL}/powerbi-token/${dto.requestedContent.type}/${dto.reportPackName}`, {
      ...dto.requestedContent
    }, {
      params: {
        code: configData.ENDPOINT_ALX_REQUEST_CODE
      }
    }).then((response) => {
      return response.data;
    }).catch((err) => {
      const error = (err as Error);
      throw new Error(`The requested report was not returned. Error: ${error.message}`);
    });
  } catch (err) {
    const error = (err as Error);
    throw new Error(`The request to the embed configuration server failed with the following message: ${error.message}`);
  }
}